export default [
  {
    path: 'maintenance',
    name: 'maintenance',
    component: resolve => {
      require(['@/modules/maintenance'], resolve);
    },
    beforeEnter: (to, from, next) => {
      if (to.params.roleName === 'maintenance') {
        next();
      } else {
        next({ path: '/' });
      }
    }
  }
];



// WEBPACK FOOTER //
// ./src/router/maintenance.js